import AutocompleteWithQuery, {
  AutocompleteWithQueryProps,
} from "components/AutocompleteWithQuery";
import useGlobalContext from "hooks/globalData";
import { useEffect } from "react";
import { useIntl } from "react-intl";
import { useQuery } from "react-query";
import {
  AdminDeliveryMethod,
  AdminListRequestOfBaseFilter,
} from "services/KnowfullyAdminClient";

type SelectDeliveryMethodProps = {
  onChange: (v: AdminDeliveryMethod | null) => void;
} & Omit<
  AutocompleteWithQueryProps<AdminDeliveryMethod>,
  "fetchedData" | "failMessage" | "labelField" | "onChange"
>;

const SelectDeliveryMethod = ({
  onChange,
  value,
  ...rest
}: SelectDeliveryMethodProps) => {
  const { formatMessage: t } = useIntl();
  const { skuService } = useGlobalContext();

  const fetchDeliveryMethods = useQuery(["getDeliveryMethods"], () =>
    skuService.getDeliveryMethods(
      new AdminListRequestOfBaseFilter({
        pageSize: -1,
        sortField: "name",
      })
    )
  );

  const deliveryMethods = fetchDeliveryMethods?.data?.data;

  useEffect(() => {
    if (deliveryMethods?.length && value) {
      onChange(deliveryMethods.find((dm) => dm.id === value) ?? null);
    }
  }, [deliveryMethods, onChange, value]);

  return (
    <AutocompleteWithQuery
      {...rest}
      value={value}
      onChange={(id) =>
        onChange(deliveryMethods?.find((dm) => dm.id === id) ?? null)
      }
      labelField={"name"}
      fetchedData={fetchDeliveryMethods}
      failMessage={t({ id: "selectDeliveryMethodFetchFailed" })}
    />
  );
};

export default SelectDeliveryMethod;
